import React from "react";
import './index.css';

export default function Banner() {
    return (
        <nav className="banner">
            <img alt="logo" src={require('../../assets/bon_music_logo.png')} />
        </nav>
    );
}